document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGaleriaProducto();
  initGaleriaZoom();
  initFormularioProducto();
  initHeroCarrusel();
  initEbsChat();
});

function initGaleriaZoom() {
  if (window.matchMedia('(hover: none)').matches) return;

  document.querySelectorAll('.ebs-pp-galeria__principal').forEach(function (contenedor) {
    var img = contenedor.querySelector('img');
    if (!img) return;

    contenedor.classList.add('ebs-pp-zoom');

    contenedor.addEventListener('mousemove', function (e) {
      var rect = contenedor.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  });
}

function initHeroCarrusel() {
  document.querySelectorAll('[data-ebs-hero-carrusel]').forEach(function (carrusel) {
    var slides = Array.prototype.slice.call(carrusel.querySelectorAll('[data-ebs-slide]'));
    if (slides.length <= 1) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var video = carrusel.querySelector('.ebs-hero__video-el');
        if (video) video.pause();
      }
      return;
    }

    var puntos = Array.prototype.slice.call(carrusel.querySelectorAll('[data-ebs-punto]'));
    var flechas = Array.prototype.slice.call(carrusel.querySelectorAll('[data-ebs-flecha]'));
    var indice = slides.findIndex(function (s) { return s.classList.contains('ebs-hero-slide--activa'); });
    if (indice < 0) indice = 0;
    var segundos = parseFloat(carrusel.dataset.ebsAutoplay) || 0;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var temporizador = null;

    function actualizarVideo(slide, activa) {
      var video = slide.querySelector('.ebs-hero__video-el');
      if (!video) return;
      if (activa && !reducido) video.play().catch(function () {});
      else video.pause();
    }

    function mostrar(nuevoIndice) {
      slides[indice].classList.remove('ebs-hero-slide--activa');
      actualizarVideo(slides[indice], false);
      puntos[indice] && puntos[indice].classList.remove('ebs-hero-carrusel__punto--activo');
      indice = (nuevoIndice + slides.length) % slides.length;
      slides[indice].classList.add('ebs-hero-slide--activa');
      actualizarVideo(slides[indice], true);
      puntos[indice] && puntos[indice].classList.add('ebs-hero-carrusel__punto--activo');
    }

    actualizarVideo(slides[indice], true);
    slides.forEach(function (s, i) { if (i !== indice) actualizarVideo(s, false); });

    function iniciarAutoplay() {
      if (segundos <= 0 || reducido) return;
      detenerAutoplay();
      temporizador = setInterval(function () { mostrar(indice + 1); }, segundos * 1000);
    }

    function detenerAutoplay() {
      if (temporizador) clearInterval(temporizador);
    }

    puntos.forEach(function (punto, i) {
      punto.addEventListener('click', function () { mostrar(i); iniciarAutoplay(); });
    });

    flechas.forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        mostrar(indice + parseInt(flecha.dataset.ebsFlecha, 10));
        iniciarAutoplay();
      });
    });

    carrusel.addEventListener('mouseenter', detenerAutoplay);
    carrusel.addEventListener('mouseleave', iniciarAutoplay);

    iniciarAutoplay();
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-ebs-miniaturas]').forEach(function (wrap) {
    var id = wrap.dataset.ebsMiniaturas;
    var principal = document.getElementById('ebs-pp-imagen-principal-' + id);
    if (!principal) return;

    wrap.querySelectorAll('.ebs-pp-miniatura').forEach(function (boton) {
      boton.addEventListener('click', function () {
        principal.src = boton.dataset.ebsImagenFull;
        principal.alt = boton.dataset.ebsImagenAlt || '';
        wrap.querySelectorAll('.ebs-pp-miniatura').forEach(function (b) {
          b.classList.remove('ebs-pp-miniatura--activa');
        });
        boton.classList.add('ebs-pp-miniatura--activa');
      });
    });
  });
}

function initFormularioProducto() {
  document.querySelectorAll('[data-ebs-producto]').forEach(function (seccion) {
    var form = seccion.querySelector('[data-ebs-form]');
    if (!form) return;

    var variantesEl = seccion.querySelector('[data-ebs-variantes]');
    var textosEl = seccion.querySelector('[data-ebs-textos]');
    if (!variantesEl) return;

    var variantes = JSON.parse(variantesEl.textContent);
    var textos = textosEl ? JSON.parse(textosEl.textContent) : { agotado: 'Agotado', comprar: 'Añadir al carrito' };
    var inputId = form.querySelector('[data-ebs-variant-input]');
    var boton = seccion.querySelector('[data-ebs-boton-comprar]');
    var botonTexto = seccion.querySelector('[data-ebs-boton-texto]');
    var precioActual = seccion.querySelector('[data-ebs-precio-actual]');
    var precioTachado = seccion.querySelector('[data-ebs-precio-tachado]');
    var stockUrgencia = seccion.querySelector('[data-ebs-stock-urgencia]');
    var gruposOpciones = seccion.querySelectorAll('[data-ebs-opcion-indice]');

    var seleccion = [];
    gruposOpciones.forEach(function (grupo) {
      var activo = grupo.querySelector('.ebs-pp-opcion__valor--activa');
      seleccion.push(activo ? activo.dataset.ebsValor : null);
    });

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' });
    }

    function actualizar() {
      var variante = variantes.find(function (v) {
        return v.options.every(function (opcion, i) { return seleccion[i] === null || opcion === seleccion[i]; });
      });
      if (!variante) return;

      inputId.value = variante.id;
      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioTachado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachado.textContent = formatearDinero(variante.compare_at_price);
          precioTachado.style.display = '';
        } else {
          precioTachado.style.display = 'none';
        }
      }
      boton.disabled = !variante.available;
      if (botonTexto) botonTexto.textContent = variante.available ? textos.comprar : textos.agotado;

      if (stockUrgencia) {
        var qty = variante.inventory_quantity;
        var rastreado = variante.inventory_management === 'shopify';
        if (rastreado && qty > 0 && qty <= 5) {
          stockUrgencia.textContent = qty === 1 ? '¡Última unidad disponible!' : '¡Solo quedan ' + qty + ' unidades!';
          stockUrgencia.hidden = false;
        } else {
          stockUrgencia.hidden = true;
        }
      }
    }

    gruposOpciones.forEach(function (grupo) {
      var indice = parseInt(grupo.dataset.ebsOpcionIndice, 10);
      grupo.querySelectorAll('.ebs-pp-opcion__valor').forEach(function (btnValor) {
        btnValor.addEventListener('click', function () {
          grupo.querySelectorAll('.ebs-pp-opcion__valor').forEach(function (b) {
            b.classList.remove('ebs-pp-opcion__valor--activa');
          });
          btnValor.classList.add('ebs-pp-opcion__valor--activa');
          seleccion[indice] = btnValor.dataset.ebsValor;
          actualizar();
        });
      });
    });
  });
}

function initReveal() {
  var elementos = document.querySelectorAll('.ebs-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('ebs-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ebs-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var contadores = document.querySelectorAll('[data-ebs-countup]');
  if (!contadores.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.ebsCountup) || 0;
        var duracion = 1400;
        var inicio = null;

        function frame(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * target);
          el.textContent = valor.toLocaleString('es-ES');
          if (progreso < 1) requestAnimationFrame(frame);
          else el.textContent = target.toLocaleString('es-ES');
        }

        requestAnimationFrame(frame);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );

  contadores.forEach(function (el) { observer.observe(el); });
}

function initEbsChat() {
  const raiz = document.querySelector('[data-ebs-chat]');
  if (!raiz) return;

  const endpoint = raiz.dataset.ebsChatEndpoint;
  const saludo = raiz.dataset.ebsChatSaludo || '¡Hola! ¿En qué puedo ayudarte?';
  const botonAbrir = raiz.querySelector('[data-ebs-chat-abrir]');
  const botonCerrar = raiz.querySelector('[data-ebs-chat-cerrar]');
  const panel = raiz.querySelector('[data-ebs-chat-panel]');
  const mensajesEl = raiz.querySelector('[data-ebs-chat-mensajes]');
  const form = raiz.querySelector('[data-ebs-chat-form]');
  const input = raiz.querySelector('[data-ebs-chat-input]');

  const STORAGE_KEY = 'ebs_chat_historial';
  let historial = [];
  try {
    const guardado = sessionStorage.getItem(STORAGE_KEY);
    if (guardado) historial = JSON.parse(guardado);
  } catch (e) {
    historial = [];
  }

  function guardarHistorial() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(historial.slice(-12)));
    } catch (e) {
      /* almacenamiento no disponible, se ignora */
    }
  }

  function pintarMensaje(texto, tipo) {
    const div = document.createElement('div');
    div.className = 'ebs-chat__msg ebs-chat__msg--' + tipo;
    div.textContent = texto;
    mensajesEl.appendChild(div);
    mensajesEl.scrollTop = mensajesEl.scrollHeight;
    return div;
  }

  function pintarHistorialInicial() {
    mensajesEl.innerHTML = '';
    pintarMensaje(saludo, 'bot');
    historial.forEach((m) => {
      pintarMensaje(m.content, m.role === 'user' ? 'user' : 'bot');
    });
  }

  let abierto = false;
  function alternarPanel(forzar) {
    abierto = typeof forzar === 'boolean' ? forzar : !abierto;
    panel.hidden = !abierto;
    raiz.classList.toggle('ebs-chat--abierto', abierto);
    if (abierto) {
      if (!mensajesEl.childElementCount) pintarHistorialInicial();
      input.focus();
    }
  }

  botonAbrir.addEventListener('click', () => alternarPanel());
  botonCerrar.addEventListener('click', () => alternarPanel(false));

  let enviando = false;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const texto = input.value.trim();
    if (!texto || enviando) return;

    pintarMensaje(texto, 'user');
    input.value = '';
    enviando = true;

    const cargando = pintarMensaje('Escribiendo...', 'cargando');

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: texto, history: historial }),
      });
      const data = await res.json();
      cargando.remove();

      if (!res.ok || data.error) {
        pintarMensaje(data.error || 'No pude responder ahora mismo. Escríbenos por WhatsApp.', 'bot');
      } else {
        pintarMensaje(data.reply, 'bot');
        historial.push({ role: 'user', content: texto });
        historial.push({ role: 'assistant', content: data.reply });
        guardarHistorial();
      }
    } catch (err) {
      cargando.remove();
      pintarMensaje('Error de conexión. Intenta de nuevo o escríbenos por WhatsApp.', 'bot');
    } finally {
      enviando = false;
    }
  });
}
